export class CustomValidator {

 

// Validates passwords
static PasswordIsValid(group): any {

const  PASSWORD_REGEXP = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/;

  if (group.pristine) {
      return null;
   }

      group.markAsTouched();   
     
   if( PASSWORD_REGEXP.test(group.value))
     return null;

  return {
      invalidPass: true
   };
}



}